import React from "react"
import styles from "./WorkingStatus.module.css"
import { ChoicesButton } from "../../../Common/CtaButton/ChoicesButton"

export const WorkingStatus = () => {
    return (
        <div className={styles.wrapper}>
            <div>
                <div className={styles.title}>
                    <h1
                        data-view-label="EF_就業状況_pv"
                        className={styles.titleText}
                    >
                        現在の状態はどうですか？
                    </h1>
                </div>
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step1/people-cook.png"
                        imageAlt="料理人イラスト"
                        text="在職中"
                        formKey={"situation"}
                        formValue={"tenure"}
                        displayFormKey={"situation"}
                        displayFormValue={"在職中"}
                        dataClickLabel="EF_就業状況_クリック"
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step1/people-normal.png"
                        imageAlt="男性イラスト"
                        text="離職中"
                        formKey={"situation"}
                        formValue={"resignation"}
                        displayFormKey={"situation"}
                        displayFormValue={"離職中"}
                        dataClickLabel="EF_就業状況_離職中"
                    />
                </div>
                <div>
                    <p className={styles.descriptionText}>
                        入力した情報は応募先の企業以外全て非公開です
                    </p>
                </div>
            </div>
        </div>
    )
}
